// Centralized data-testid registry
export const NAV = {
  brand: "nav-brand",
  link: (id) => `nav-link-${id}`,
  resumeBtn: "nav-resume-btn",
  commandBtn: "nav-command-btn",
};

export const HERO = {
  section: "hero-section",
  name: "hero-name",
  role: "hero-role",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  socialLink: (id) => `hero-social-${id}`,
  statCard: (id) => `hero-stat-${id}`,
  availableBadge: "hero-available-badge",
};

export const ABOUT = { section: "about-section" };
export const SKILLS = { section: "skills-section", card: (id) => `skill-card-${id}` };
export const EXPERIENCE = { section: "experience-section", card: (id) => `experience-card-${id}` };
export const PROJECTS = {
  section: "projects-section",
  filter: (id) => `projects-filter-${id}`,
  card: (id) => `project-card-${id}`,
  modalClose: "projects-modal-close",
};
export const CERTIFICATIONS = { section: "certifications-section" };
export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  subject: "contact-input-subject",
  message: "contact-input-message",
  submit: "contact-submit-btn",
  success: "contact-success",
  error: "contact-error",
  visitorCount: "contact-visitor-count",
};
export const FOOTER = { root: "footer-root" };
export const COMMAND = { palette: "command-palette", input: "command-input", item: (id) => `command-item-${id}` };
